import ApiService from '@/services/api.service';

const PatientPortalChangeInfoService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalChangeInfoRequests/',
            headers: {},
            params: parameters,
            paramsSerializer: params => ApiService.parseParams(params)
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalChangeInfoRequests/${id}`);
    },

    update(id) {
        return ApiService.put(`/PatientPortalChangeInfoRequests/ApplyChanges/${id}`);
    },

    discard(id, isNewRequest) {
        const requestData = {
            method: 'put',
            url: `/PatientPortalChangeInfoRequests/Discard/${id}`,
            headers: {},
            params: { isNewRequest }
        };
        return ApiService.customRequest(requestData);
    },

    getNewRequestsCount() {
        return ApiService.get('/PatientPortalChangeInfoRequests/count-new-requests');
    }
};

export default PatientPortalChangeInfoService;
